var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-container',{attrs:{"items":_vm.items,"loading":_vm.loading,"title":_vm.title},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
var tileHeight = ref.tileHeight;
return [_c('v-col',{key:item.uuid,attrs:{"id":item.uuid,"cols":"12","lg":"4","md":"6"}},[_c('stats-card',{attrs:{"height":tileHeight,"item":item}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }